export const PaymentEndpoints = {
  //Payment Plans --------------------
  getPaymentPlans: process.env['NEXT_PUBLIC_API'] + '/payments/plans',

  //Subscriptions --------------------
  //POST
  createSubscription:
    process.env['NEXT_PUBLIC_API'] + '/payments/create-subscription',
  //PATCH
  cancelSubscription:
    process.env['NEXT_PUBLIC_API'] + '/payments/cancel-subscription',
  // PATCH
  updateSubscriptionPayment:
    process.env['NEXT_PUBLIC_API'] + '/payments/subscription',

  // Payment Methods --------------------
  createPaymentMethod: process.env['NEXT_PUBLIC_API'] + '/payments/methods',
  //DELETE - requires /:methodId
  deletePaymentMethod: process.env['NEXT_PUBLIC_API'] + '/payments/methods',

  //School Checkout --------------------
  getTeacherTransactions:
    process.env['NEXT_PUBLIC_API'] + '/teachers/transactions',
  createSchoolCheckout:
    process.env['NEXT_PUBLIC_API'] + '/payments/school/create-checkout',

  //Transactions --------------------
  getInvoices:
    process.env['NEXT_PUBLIC_API'] + '/payments/subscription/transactions',
  downloadTransactions:
    process.env['NEXT_PUBLIC_API'] +
    '/payments/subscription/download-transactions',
  downloadSchoolTransactions:
    process.env['NEXT_PUBLIC_API'] + '/teachers/download-transactions',

  //School Credits --------------------
  purchaseSchoolCredits:
    process.env['NEXT_PUBLIC_API'] + '/payments/school/create-checkout',
};
